export interface IApiClubPhotoDetail {
  PhotoID: number;
  ThumbUrl: string;
  FullUrl: string;
  Width: number;
  Height: number;
  IsMain: boolean;
}

export default class clubPhotoDetail {
  photoId: number;
  thumbUrl: string;
  fullUrl: string;
  width: number;
  height: number;
  isMain: boolean;
  isPublic: boolean;
  isAccepted: boolean;
  FullUrl?: string; // Original JS has this duplicate property assignment

  constructor() {
    this.photoId = 0;
    this.thumbUrl = '';
    this.fullUrl = '';
    this.width = 0;
    this.height = 0;
    this.isMain = false;
    this.isPublic = true;
    this.isAccepted = true;
  }

  static mappingObject(user: IApiClubPhotoDetail): clubPhotoDetail {
    const profile = new clubPhotoDetail();
    if (user) {
      profile.photoId = user.PhotoID;
      profile.thumbUrl = user.ThumbUrl;
      profile.fullUrl = user.FullUrl;
      profile.FullUrl = user.FullUrl; // Preserving original JS behavior
      profile.width = user.Width;
      profile.height = user.Height;
      profile.isMain = user.IsMain;
    }
    return profile;
  }

  static mappingObjects(_users: IApiClubPhotoDetail[]): clubPhotoDetail[] {
    const users: clubPhotoDetail[] = [];
    _users.forEach(_user => {
      const user = clubPhotoDetail.mappingObject(_user);
      users.push(user);
    });
    return users;
  }
}
